/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/callEngine/processedData.js
 * @Author: Yongchao Wang
 * @Date: 2021-08-18 20:36:15
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-01-18 10:43:03
 */

import CornerCabinetPlate from '@/3DEngine/render/specialHandler/cornerCabinetPlate';
import { FRAMECATEGORY } from '../render/utils/kitchenConfig';
import { checkFrameIsHighFrame } from '../render/utils/renderUtils';

// position是用于分辨改的是否是顶柜门板，改顶柜门板需要特殊处理
export function getSidePlates(templateJson, position) {
  let bottom = [];
  let top = [];
  [templateJson?.top?.length1,
    templateJson?.top?.length2,
    templateJson?.top?.length3].forEach((length) => {
    if (!length) {
      return;
    }
    length?.sidePlates?.forEach((element) => {
      top = top.concat({ componentBasic: element });
    });
    // 改顶柜侧板时需要判断该length上最后一个柜子是否是高柜
    // 如果是高柜，高柜的侧板不需要替换，
    if (length?.sidePlates?.length > 0
      && position === 'top' && checkFrameIsHighFrame(length.frames[length.frames.length - 1])) {
      top.pop();
    }
  });
  [templateJson?.bottom?.length1?.sidePlates,
    templateJson?.bottom?.length2?.sidePlates,
    templateJson?.bottom?.length3?.sidePlates].forEach((sidePlates) => {
    if (!sidePlates) {
      return;
    }
    sidePlates.forEach((element) => {
      bottom = bottom.concat({ componentBasic: element });
    });
  });
  return {
    bottom, top,
  };
}
export function getSealPlates(templateJson) {
  let bottom = [];
  let top = [];
  [templateJson?.top?.length1?.sealPlate,
    templateJson?.top?.length2?.sealPlate,
    templateJson?.top?.length3?.sealPlate].forEach((sealPlate) => {
    if (!sealPlate) {
      return;
    }
    sealPlate.forEach((element, index) => {
      // 补板换色只需要换正面（下标为1）的板子
      if (element.width && index === 1) {
        top = top.concat({ componentBasic: { ...element, showType: 1 } });
      }
    });
  });
  [templateJson?.bottom?.length1?.sealPlate,
    templateJson?.bottom?.length2?.sealPlate,
    templateJson?.bottom?.length3?.sealPlate].forEach((sealPlate) => {
    if (!sealPlate) {
      return;
    }
    sealPlate.forEach((element) => {
      if (element.width) {
        bottom = bottom.concat({ componentBasic: { ...element, showType: 1 } });
      }
    });
  });
  return {
    bottom, top,
  };
}
/**
 * 解析拿到转角柜补板
 * @param {*} templateJson templateJson
 */
export function getCornerPlates(templateJson) {
  const tmpSealPlateArr = CornerCabinetPlate.getCornerCabinetPlateMesh(templateJson);
  const sealPlateArr = [];
  if (tmpSealPlateArr[0] && tmpSealPlateArr[0].length > 0) {
    tmpSealPlateArr[0].forEach((item) => {
      sealPlateArr.push({
        componentBasic: {
          ...item,
          showType: 2,
        },
      });
    });
  }
  return sealPlateArr;
}


export function getDoors(templateJson) {
  let bottom = [];
  let top = [];
  // categoryId为10 沃拓普和普通柜门 柜门数量不一样，换柜门直接重新init
  let highFrame10 = false;
  // version 2.0沃拓普高柜需要单独处理门板，所以需要将整个高柜返回
  let highFrame = [];
  let inTopHighFrame = [];
  [templateJson?.bottom?.length1?.frames,
    templateJson?.bottom?.length2?.frames,
    templateJson?.bottom?.length3?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }

    frames.forEach((element) => {
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        highFrame10 = true;
      }
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_11
        || element?.categoryId === FRAMECATEGORY.CATEGORY_12) {
        // highFrame = element;
        highFrame = highFrame.concat(element);
      }
      bottom = bottom.concat(element.doors);
    });
  });
  [templateJson?.top?.length1?.frames,
    templateJson?.top?.length2?.frames,
    templateJson?.top?.length3?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }
    frames.forEach((element) => {
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        highFrame10 = true;
      }
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_11
        || element?.categoryId === FRAMECATEGORY.CATEGORY_12) {
        // inTopHighFrame = element;
        inTopHighFrame = inTopHighFrame.concat(element);
      }
      // if (checkFrameIsHighFrame(element)) {
      //   return;
      // }
      top = top.concat(element.doors);
    });
  });
  return {
    bottom, top, highFrame10, highFrame, inTopHighFrame,
  };
}

export function getDoorsAndHighFrameDoors(templateJson) {
  let bottom = [];
  let bottomHighFrame = [];
  let top = [];
  let topHighFrame = [];
  // categoryId为10 沃拓普和普通柜门 柜门数量不一样，换柜门直接重新init
  let highFrame10 = false;
  // version 2.0沃拓普高柜需要单独处理门板，所以需要将整个高柜返回
  let inBottomHighFrame = [];
  let inTopHighFrame = [];
  [templateJson?.bottom?.length1?.frames,
    templateJson?.bottom?.length2?.frames,
    templateJson?.bottom?.length3?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }

    frames.forEach((element) => {
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        highFrame10 = true;
      }
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_11
        || element?.categoryId === FRAMECATEGORY.CATEGORY_12
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        // inBottomHighFrame = element;
        inBottomHighFrame = inBottomHighFrame.concat(element);
        bottomHighFrame = bottomHighFrame.concat(element.doors);
      } else {
        bottom = bottom.concat(element.doors);
      }
    });
  });
  [templateJson?.top?.length1?.frames,
    templateJson?.top?.length2?.frames,
    templateJson?.top?.length3?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }
    frames.forEach((element) => {
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        highFrame10 = true;
      }
      if (element?.categoryId === FRAMECATEGORY.CATEGORY_10
        || element?.categoryId === FRAMECATEGORY.CATEGORY_11
        || element?.categoryId === FRAMECATEGORY.CATEGORY_12
        || element?.categoryId === FRAMECATEGORY.CATEGORY_33
        || element?.categoryId === FRAMECATEGORY.CATEGORY_34
        || element?.categoryId === FRAMECATEGORY.CATEGORY_35
        || element?.categoryId === FRAMECATEGORY.CATEGORY_36
        || element?.categoryId === FRAMECATEGORY.CATEGORY_37
      ) {
        // inTopHighFrame = element;
        inTopHighFrame = inTopHighFrame.concat(element);
        topHighFrame = topHighFrame.concat(element.doors);
      } else {
        top = top.concat(element.doors);
      }
    });
  });
  return {
    bottom, top, highFrame10, inBottomHighFrame, topHighFrame, bottomHighFrame, inTopHighFrame,
  };
}

export function getSink(templateJson) {
  let sink;
  let edge;
  [templateJson?.bottom?.length1?.frames,
    templateJson?.bottom?.length2?.frames,
    templateJson?.bottom?.length3?.frames].forEach((frames, index) => {
    if (!frames) {
      return;
    }
    frames.forEach((element) => {
      if (element.sink) {
        sink = element.sink;
        edge = index;
      }
    });
  });
  return { sink, edge };
}

export function getFaucet(templateJson) {
  let faucet;
  let edge;
  [templateJson?.bottom?.length1?.frames,
    templateJson?.bottom?.length2?.frames,
    templateJson?.bottom?.length3?.frames].forEach((frames, index) => {
    if (!frames) {
      return;
    }
    frames.forEach((element) => {
      if (element.sink) {
        if (element.sink.faucet) {
          faucet = element.sink.faucet;
        }
        edge = index;
      }
    });
  });
  return { faucet, edge };
}

export function getHandles(templateJson) {
  const { bottom, top } = getDoors(templateJson);
  const bottomHandles = bottom.filter((e) => e.handle).map((e) => e.handle);
  const topHandles = top.filter((e) => e.handle).map((e) => e.handle);
  return { bottom: bottomHandles, top: topHandles };
}

export function getHighFrame(templateJson) {
  let highFrame;
  [templateJson?.bottom?.length1?.frames,
    templateJson?.bottom?.length2?.frames,
    templateJson?.bottom?.length3?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }
    frames.forEach((element) => {
      if (checkFrameIsHighFrame(element)) {
        highFrame = element;
      }
    });
  });
  return highFrame;
}

export function setTopFramesHighFrame(templateJson, highFrame) {
  if (!highFrame) {
    return templateJson;
  }
  const tempHighFrame = JSON.parse(JSON.stringify(highFrame));
  tempHighFrame.componentBasic.show = false;
  const length1 = templateJson?.top?.length1?.frames?.map((element) => {
    if (checkFrameIsHighFrame(element)) {
      return tempHighFrame;
    }
    return element;
  });
  const length2 = templateJson?.top?.length2?.frames?.map((element) => {
    if (checkFrameIsHighFrame(element)) {
      return tempHighFrame;
    }
    return element;
  });
  const length3 = templateJson?.top?.length3?.frames?.map((element) => {
    if (checkFrameIsHighFrame(element)) {
      return tempHighFrame;
    }
    return element;
  });
  const tempJson = templateJson;
  if (tempJson?.top?.length1?.frames) {
    tempJson.top.length1.frames = length1;
  }
  if (tempJson?.top?.length2?.frames) {
    tempJson.top.length2.frames = length2;
  }
  if (tempJson?.top?.length3?.frames) {
    tempJson.top.length3.frames = length3;
  }

  return tempJson;
}

export function existWindow(templateJson) {
  const frames = [
    templateJson.bottom?.length1,
    templateJson.bottom?.length2,
    templateJson.bottom?.length3,
    templateJson.top?.length1,
    templateJson.top?.length2,
    templateJson.top?.length3,

  ];

  let window;
  frames.forEach((lengthFrames) => {
    if (lengthFrames) {
      lengthFrames.frames.forEach((e) => {
        if (e.window) {
          window = e.window;
        }
      });
    }
  });

  return !!window;
}
